import { useQuery } from "@tanstack/react-query";
import axios from "../../axiosConfig";
import { GET_TOTAL_ACTUAL_HOURS } from "../queries/GetProductFamilies";

const fetchActualTotalHours = async ({ queryKey }) => {
    const [, { token, plantProd, accounts }] = queryKey;

    if (!token) throw new Error("Token not available");

    try {
        const url = `/getTotalHrs/${encodeURIComponent(accounts[0].username)}?PlantProdFamilyId=${encodeURIComponent(plantProd)}`;

        const response = await axios.get(url, {
          headers: {
            Authorization: token,
          },
        });

        return response.data;

    } catch (error) {
        throw new Error(error.response?.data || "Error fetching data");
    }
};

export const useGetTotalActualHrs = (params) => {
    return useQuery({
        queryKey: [GET_TOTAL_ACTUAL_HOURS, params],
        queryFn: fetchActualTotalHours,
        enabled: !!params.token,
        retry: false,
    });
};

